//Module Keys
let locales = {};

//Merge Views
import results from 'Modules/transactions/views/results/lan/en';
import dataDetails from 'Modules/transactions/.components/dataDetails/lan/en';
import requests from 'Modules/transactions/views/main/lan/en';
import transactionsDetails from 'Modules/transactions/.components/transactionsDetails/lan/en';

locales = {
    ...locales,
    ...results,
    ...dataDetails,
    ...requests,
    ...transactionsDetails,
    
};

export default locales;